document.addEventListener('DOMContentLoaded', function () {
    const animationScope = document.querySelector('gradient') || document.body;
    gsap.registerPlugin(ScrollTrigger, SplitText);
    gsap.set(".header", { opacity: 1 });

    // --- Animation 1: Title ---
    const animatedTitles = document.querySelectorAll('.animated-title');

    animatedTitles.forEach((titleContainer) => {
        const split = new SplitText(titleContainer, { 
            type: "lines,words", 
            linesClass: "title-line",
            reduceWhiteSpace: false,
        });
        
        const words = split.words; 

        if (words.length === 0) return;

        gsap.set(words, { y: '110%' });

        gsap.to(words, {
            y: '0%',
            duration: 0.8,
            stagger: 0.1,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: titleContainer,
                start: 'top 90%', 
                once: true,      
            },
        });
    });

    // --- Animation 2: Text ---
    document.fonts.ready.then(() => {
    const textContainers = document.querySelectorAll('.animated-text');

    textContainers.forEach((container) => {
        const split = new SplitText(container, { type: 'lines' });

        if (!split.lines || split.lines.length === 0) return;

        gsap.set(split.lines, { opacity: 0, y: "100%" });

        gsap.to(split.lines, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
            trigger: container,
            start: 'top 90%',
            once: true,
        },
        });
    });
    });

    // ---- Animation 3: Media ---
    const animatedMedia = document.querySelectorAll('.animated-media');

    animatedMedia.forEach((media) => {
        gsap.set(media, { opacity: 0, y: '25%' });

        gsap.to(media, {
        opacity: 1,
        y: '0%',
        duration: 1, 
        ease: 'power2.out',
        scrollTrigger: {
            trigger: media,
            start: 'top 90%', 
            once: true,
        },
        });
    });

    setTimeout(() => {
        animationScope.classList.add('gsap-ready');
    }, 50); 
});

// ---- Animation 4: Button ---
class CustomButton extends HTMLElement {
    
    constructor() {
        super(); 

        const text = this.getAttribute('text') || 'Learn More';
        const link = this.getAttribute('link') || '#';
        
        // 安全检查：确保 assets 变量已加载
        let iconPath;
        if (typeof window.assets !== 'undefined') {
            iconPath = this.getAttribute('icon-path') || window.assets.buttonIcon;  
        } else {
            console.error('Button icon asset not loaded. Check Liquid injection.');
            iconPath = this.getAttribute('icon-path') || window.assets.buttonIcon;
        }

        this.innerHTML = `
            <a href="${link}" class="custom-button">
                <span class="button-text-container">
                    <span class="button-text-top">${text}</span>
                    <span class="button-text-bottom">${text}</span>
                </span>
                <span class="button-icon">
                    <img src="${iconPath}" alt="Arrow icon">
                </span>
            </a>
        `;
    }
}

customElements.define('custom-button', CustomButton);


